// A logout while offline cannot end the server session. The device logs out locally and
// remembers to finish the logout the next time `/api/me` is asked while online, so the
// previous user is never silently back in.
const PENDING_LOGOUT = "zt-pending-logout";

export function markPendingLogout(): void {
  try {
    localStorage.setItem(PENDING_LOGOUT, "1");
  } catch {
    // No storage: the server session simply lives on until it expires.
  }
}

export function hasPendingLogout(): boolean {
  try {
    return localStorage.getItem(PENDING_LOGOUT) === "1";
  } catch {
    return false;
  }
}

export function clearPendingLogout(): void {
  try {
    localStorage.removeItem(PENDING_LOGOUT);
  } catch {
    // ignore
  }
}
